import { render, staticRenderFns } from "./CBlockMap.vue?vue&type=template&id=1c6b9488&"
import script from "./CBlockMap.vue?vue&type=script&lang=ts&"
export * from "./CBlockMap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports